<div class="div__sobre__chamado">
  <ng-content></ng-content>
</div>
